import { createFileRoute } from "@tanstack/react-router";
import { myProfileQueryOptions } from "~/features/myProfile/api";
import { EmailChangeTemplate } from "~/features/myProfile/EmailChangeTemplate";

// MyProfileTemplate（layout）の上に全画面オーバーレイで重ねる。
// 中身は PageContainer（min-h-screen・自前スクロールなし）でページスクロール前提のため、
// fixed の overlay 自体を overflow-y-auto でスクロール可能にする。
const EmailPage = () => (
  <div className="fixed inset-0 z-40 overflow-y-auto overscroll-contain bg-white">
    <EmailChangeTemplate />
  </div>
);

export const Route = createFileRoute("/_authenticated/my-page/email")({
  loader: ({ context: { queryClient } }) =>
    queryClient.ensureQueryData(myProfileQueryOptions),
  component: EmailPage,
});
